import React, { useEffect, useState } from "react";

// Loacal imports
import PageLoader from "../global/page-loader";
import CTAStrip from "../global/cta.strip";

// Live imports
import { NavLink as Link, withRouter } from "react-router-dom";
import axios from "axios";
import { route } from "../global/route.global";
function AboutCompanyProfile() {
  const [content, setContent] = useState("");
  const [year, setYear] = useState(0);
  const [lastUpdate, setLastUpdate] = useState("");

  useEffect(() => {
    getContent();
  }, []);
  const getContent = async () => {
    const instance = axios.create({});
    await instance
      .get(route.root.profile)
      .then(async (res) => {
        // var _rn = regsNorth;
        // var _rs = regsSouth;
        // var _total = _rn + _rs;
        // setRegsTotal(_total);
        setContent(res.data.data.content);
        setYear(res.data.data.year);
        setLastUpdate(res.data.data.last_update);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <>
      <PageLoader />
      <div className="breadcrumb-wrapper">
        <div className="images-overlay"></div>
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="page-heading">
                <h1>
                  About <span>Us</span>
                </h1>
                <span className="line"></span>
              </div>
              <div className="page-breadcrumb-inner">
                <div className="page-breadcrumb">
                  <div className="breadcrumb-list">
                    <ul>
                      <li>
                        <Link to="/" activeclass="active">
                          Home
                        </Link>
                      </li>
                      <li>
                        <Link to="/about-us" activeclass="active">
                          About
                        </Link>
                      </li>
                      <li>
                        <Link
                          exact
                          to="/about/company-profile"
                          activeclass="active"
                        >
                          Company Profile
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <section id="about-us" className="inner-page-wrapper about-wrapper">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-xl-9 about-text">
              {content !== "" ? (
                <div dangerouslySetInnerHTML={{ __html: content }} />
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      </section>
      <CTAStrip />
    </>
  );
}

export default withRouter(AboutCompanyProfile);
